import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar, EffectFade } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade]);

$('.processslider_f41b').each(function() {
  var $this = $(this);
  var $scrollbar = $(this).find('.swiper-scrollbar');

  var slider = new Swiper($this[0], {
    slidesPerView: 1,
    effect: 'fade',
    speed: 500,
    fadeEffect: { crossFade: true },
    noSwiping: true, // Disable swiping on all elements
    noSwipingClass: 'swiper-no-swiping, .swiper-pagination-bullets, .swiper-pagination-bullet',
    noSwipingSelector: '.swiper-pagination-bullets, .swiper-pagination-bullet', 
    allowTouchMove: false,
    touchRatio: 1,
    autoplay: {
      delay: 2000,
    },
    scrollbar: {
      el: $scrollbar[0],
      draggable: false,
      
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      
    },
  });
  $('.go-to-next-slide').on('click', function(e){
    e.preventDefault();
    slider.slideNext();
  });
});